import api from "!../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.75.0_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.75.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../node_modules/.pnpm/postcss-loader@5.3.0_postcss@8.4.20_webpack@5.75.0_webpack-cli@4.10.0_/node_modules/postcss-loader/dist/cjs.js!../../node_modules/.pnpm/less-loader@9.1.0_less@4.1.3_webpack@5.75.0_webpack-cli@4.10.0_/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./styles.less";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};